import { useEffect } from 'react';

// Firebase handles auth callbacks internally — this just redirects home
// in case a Clerk-era URL is ever hit.
export default function AuthCallback() {
  useEffect(() => { window.location.replace('/'); }, []);
  return null;
}
